// https://github.com/Microsoft/TypeScript/issues/12756#issuecomment-265812676

import * as React from 'react';
import * as Contentful from 'contentful'
import { ContentfulClientApi } from 'contentful'
import { withConfig } from  '../../common/modules/config'
import { omit } from 'lodash' 

export type Wrapped<P> = React.ComponentClass<P> | React.StatelessComponent<P>;


const specifiedEnvironment = process.env.REACT_APP_ENVIRONMENT;
const isStage = specifiedEnvironment != "production";

const defaultClient = Contentful.createClient({
    space: process.env.REACT_APP_CONTENTFUL_ISAVER_SPACE,
    accessToken: process.env.REACT_APP_CONTENTFUL_ISAVER_ACCESS_TOKEN,
    resolveLinks: true,
    host: process.env.REACT_APP_CONTENTFUL_ISAVER_HOST
})


if(isStage){
    console.log("CONTENTFUL STAGE: DRAFT");
}else{
    console.log("CONTENTFUL PRODUCTION");
}


export interface HOCProps {
    client: ContentfulClientApi;
}


export interface PartialHocProps{
    client?:ContentfulClientApi
}


interface State{
    client: ContentfulClientApi
}


export default function <P>(Component: React.ComponentClass<P & HOCProps>): React.ComponentClass< P | PartialHocProps > {

    return class extends React.Component<P, State> {

        constructor(props){
            super(props);
            this.state = {
                client: {
                    ...defaultClient,
                    getEntries: (query?) => {
                        const promise = defaultClient.getEntries(query);
                        promise.then(response => {
                            console.log(response)
                            return response;
                        })
                        promise.catch(err => {
                            console.log("ERROR")
                            console.log(err);
                            return err;
                        })
                        return promise;
                    }
                }
            }
        }


        componentWillMount(){
            console.log("Top mounted")
        }


        public render() {
            return (
                <Component client={ this.state.client } {...this.props as any} />
            );
        }
    }

}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/high-order/with-contentful.tsx